/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type PeopleSettingsType from '@jira/spa-apps__project-settings-people/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { type RouteContext, type Match, Redirect } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyPeopleSettings: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof PeopleSettingsType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-people", jiraSpaEntry: "async-project-settings-people" */ '@jira/spa-apps__project-settings-people/src/index.tsx'
			),
		),
	);

const PeopleAccessRedirectInner = ({ match, basePath }: { basePath: string; match: Match }) => (
	<Redirect
		to={`${basePath}/projects/${String(match.params.projectKey)}/settings/access`}
		push={false}
	/>
);

export const peopleAccessRedirect =
	(basePath: string) =>
	({ match }: RouteContext): React.JSX.Element => (
		<PeopleAccessRedirectInner match={match} basePath={basePath} />
	);

const AsyncPeopleSettings = (): React.JSX.Element => (
	<LazyPage Page={LazyPeopleSettings} pageId="project-settings-people" shouldShowSpinner={false} />
);

export default AsyncPeopleSettings;
